import React from "react";
import { formatName } from "../../../../helpers/helpers";
import { OCC_STATUS_PILL } from "../tasks_hub/taskHubUtils";

// The one status pill for a task occurrence, shared by the Now list, the task
// cards, and the checklist modal so every surface says the same thing:
// New / Acknowledged / In Progress / Waiting: Validation / Completed.
// Overdue and late are flags, shown as a caption after the pill.
//
// Accepts the occurrence's lifecycle fields directly, or the legacy five-string
// `status` for callers that still pass it.

const LEGACY_TO_LIFECYCLE = {
  not_started: "new",
  in_progress: "in_progress",
  overdue: "new",
  completed: "completed",
  completed_late: "completed",
};

const TaskStatusBadge = (props) => {
  const lifecycle =
    props.lifecycleStatus || LEGACY_TO_LIFECYCLE[props.status] || "new";
  const isOverdue = props.isOverdue ?? props.status === "overdue";
  const isLate = props.isLate ?? props.status === "completed_late";
  const isSubmitted = lifecycle === "completed" || lifecycle === "waiting_validation";
  const c = OCC_STATUS_PILL[lifecycle] || OCC_STATUS_PILL.new;
  const submitterName =
    isSubmitted && props.submittedBy ? formatName(props.submittedBy) : null;

  const pill = (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full pl-2 pr-2.5 py-0.5 ${c.bg} border ${c.border} whitespace-nowrap`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot}`} />
      <span className={`text-[11px] font-semibold leading-4 ${c.text}`}>
        {c.label}
      </span>
    </span>
  );

  const caption = isSubmitted
    ? [
        isLate ? "Late" : null,
        props.submitted_at ? `@ ${props.submitted_at}` : null,
        submitterName ? `· ${submitterName}` : null,
      ]
        .filter(Boolean)
        .join(" ")
    : isOverdue
    ? "Overdue"
    : null;

  if (props.size === "chip") {
    return (
      <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
        {pill}
        {caption && (
          <span className={`text-[11px] font-semibold ${isOverdue && !isSubmitted ? "text-rose-600" : isLate ? "text-amber-700" : "text-slate-500"}`}>
            {caption}
          </span>
        )}
      </span>
    );
  }

  return (
    <div className="flex flex-col items-end gap-0.5">
      {pill}
      {caption && (
        <span className={`text-[10px] ${isOverdue && !isSubmitted ? "text-rose-600 font-semibold" : "text-slate-400"}`}>
          {caption}
        </span>
      )}
    </div>
  );
};

export default TaskStatusBadge;
